"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.background"));

var _styled = require("./styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// External Dependencies
var AccountCard = function AccountCard(_ref) {
  var name = _ref.name,
      image = _ref.image,
      active = _ref.active,
      onClick = _ref.onClick;
  return _react["default"].createElement(_styled.AccountCardWrapper, {
    onClick: onClick
  }, _react["default"].createElement(_styled.CardContainer, null, _react["default"].createElement(_styled.AccountThumbnail, null, _react["default"].createElement(_knotchincWebReactComponents["default"], {
    url: image
  })), _react["default"].createElement(_styled.CardLabel, null, _react["default"].createElement("div", {
    className: "entityName"
  }, name, active && _react["default"].createElement(_styled.ActiveLabel, null, _react["default"].createElement("span", null, "ACTIVE"))))));
};

var _default = AccountCard;
exports["default"] = _default;

//# sourceMappingURL=AccountCard.js.map